<template>
  <Breadcrumbs title="pageTitle" />
  <Card1
    colClass="col-sm-12"
    cardhaderClass="pb-0 title-header"
    title="Create Workspace"
  >
    <br />
    <br />
    <br />
    <div class="horizontal-wizard-wrapper vertical-options vertical-variations">
      <div class="row g-3">
        <div class="col-xl-3 main-horizontal-header">
          <div
            class="nav nav-pills horizontal-options"
            id="vertical-n-wizard-tab"
            role="tablist"
            aria-orientation="vertical"
          >
            <a
              class="nav-link active"
              id="wizard-n-info-tab"
              data-bs-toggle="pill"
              href="#wizard-n-info"
              role="tab"
              aria-controls="wizard-n-info"
              aria-selected="true"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>1</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Get Started</h3>
                </div>
              </div>
            </a>
            <a
              class="nav-link"
              id="bank-n-wizard-tab"
              data-bs-toggle="pill"
              href="#bank-n-wizard"
              role="tab"
              aria-controls="bank-n-wizard"
              aria-selected="false"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>2</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Workspace Setup</h3>
                </div>
              </div>
            </a>
            <a
              class="nav-link"
              id="inquiry-n-wizard-tab"
              data-bs-toggle="pill"
              href="#inquiry-n-wizard"
              role="tab"
              aria-controls="inquiry-n-wizard"
              aria-selected="false"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>3</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Define Lanes</h3>
                </div>
              </div>
            </a>
            <a
              class="nav-link"
              id="user-managment-n-wizard-tab"
              data-bs-toggle="pill"
              href="#user-managment-n-wizard"
              role="tab"
              aria-controls="user-managment-n-wizard"
              aria-selected="false"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>4</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Team Planning</h3>
                </div>
              </div>
            </a>
            <a
              class="nav-link"
              id="successful-n-wizard-tab"
              data-bs-toggle="pill"
              href="#successful-n-wizard"
              role="tab"
              aria-controls="successful-n-wizard"
              aria-selected="false"
            >
              <div class="horizontal-wizard">
                <div class="stroke-icon-wizard"><span>5</span></div>
                <div class="horizontal-wizard-content">
                  <h3>Completed</h3>
                </div>
              </div>
            </a>
          </div>
        </div>
        <div class="col-xl-9">
          <div class="tab-content dark-field" id="vertical-n-wizard-tabContent">
            <basicInfo @continue="handleStep1" />
            <moduleInfo @continue="handleStep2" />
            <featureinfo @continue="handleStep3" />
            <usersManagement @continue="handleStep4" />

            <div
              class="tab-pane fade"
              id="successful-n-wizard"
              role="tabpanel"
              aria-labelledby="successful-n-wizard-tab"
            >
              <finalStep :payload="workspacePayload" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </Card1>
</template>

<script lang="ts" setup>
import { reactive, defineAsyncComponent } from "vue";
import * as bootstrap from "bootstrap";

const Card1 = defineAsyncComponent(
  () => import("@/components/commen/card/cardData1.vue")
);
const basicInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/basicInfo.vue")
);
const moduleInfo = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/moduleInfo.vue")
);
const featureinfo = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/laneInfo.vue")
);
const finalStep = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/finalStep.vue")
);
const usersManagement = defineAsyncComponent(
  () => import("@/components/theme/admin/projects/teamPlanning.vue")
);

// ─── Shared payload restructured to match user's requested sample ───────────
const workspacePayload = reactive({
  company_id: "693957131e9c3a2e76c806ac", // Dummy for now
  variables: {
    title: "",
    "workspace-type": "",
    "workspace-industries": [] as string[],
    roles: [] as any[],
  },
  logo: null as string | null,
  lanes: [] as any[],
  description: "", // Hidden in final payload if not needed, but kept for review
});

// ─── Tab switching helper ────────────────────────────────────────────────────
function switchToTab(identifier: string | number): boolean {
  let tabLink: HTMLElement | null = null;

  if (typeof identifier === "string") {
    tabLink = document.querySelector(`#${identifier}`) as HTMLElement;
  } else if (typeof identifier === "number") {
    const tabLinks = document.querySelectorAll(
      "#vertical-n-wizard-tab .nav-link"
    );
    tabLink = tabLinks[identifier] as HTMLElement;
  }

  if (tabLink && typeof bootstrap !== "undefined" && bootstrap.Tab) {
    try {
      const tab = new bootstrap.Tab(tabLink);
      tab.show();
      return true;
    } catch (error) {
      console.error("Failed to switch tab:", error);
      return false;
    }
  } else {
    console.error(
      `Tab not found or Bootstrap Tab API unavailable. Identifier: ${identifier}`
    );
    return false;
  }
}

// ─── Step handlers ───────────────────────────────────────────────────────────
function handleStep1(data: { description: string }) {
  workspacePayload.description = data.description;
  switchToTab("bank-n-wizard-tab");
}

function handleStep2(data: {
  logo: string | null;
  workspaceName: string;
  workspaceType: string;
  industryId: string;
}) {
  workspacePayload.logo = data.logo;
  workspacePayload.variables.title = data.workspaceName;
  workspacePayload.variables["workspace-type"] = data.workspaceType;
  // Wrap single industry in array as per required format
  workspacePayload.variables["workspace-industries"] = data.industryId ? [data.industryId] : [];
  switchToTab("inquiry-n-wizard-tab");
}

function handleStep3(data: { lanes: any[] }) {
  workspacePayload.lanes = data.lanes;
  switchToTab("user-managment-n-wizard-tab");
}

function handleStep4(data: { teams: any[] }) {
  workspacePayload.variables.roles = data.teams;
  switchToTab("successful-n-wizard-tab");
}
</script>
